import { render } from "./icon-svg.vue?vue&type=template&id=22a08924"
import script from "./icon-svg.vue?vue&type=script&lang=js"
export * from "./icon-svg.vue?vue&type=script&lang=js"

import "./icon-svg.vue?vue&type=style&index=0&id=22a08924&lang=css"

import exportComponent from "D:\\工作空间\\xx-fds-protal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__